import { render, staticRenderFns } from "./ApplyProjectQuota.vue?vue&type=template&id=0ec8177f&"
import script from "./ApplyProjectQuota.vue?vue&type=script&lang=js&"
export * from "./ApplyProjectQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports